import React from "react";
import moment from "moment";

const returnYears = () => {
  let years = [];
  for (let i = moment().year() - 7; i <= moment().year() + 2; i++) {
    years.push(<option value={i}>{i}</option>);
  }
  return years;
};

const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <div>
      <select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)}>
        {moment.months().map((label, value) => (
          <option value={value}>{label}</option>
        ))}
      </select>
    </div>
    <div>
      <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
        {returnYears()}
      </select>
    </div>
  </div>
);

export { renderMonthElement };
